import { createBrowserRouter } from "react-router";
import { lazy, Suspense } from "react";

import { PaymentConfirmed } from "./pages/payment-confirmed";
import { Support } from "./pages/support";
import { IspPage } from "./pages/isp";

const MvnoPage = lazy(() =>
  import("./pages/mvno").then((m) => ({ default: m.MvnoPage }))
);

export const routes = createBrowserRouter([
  {
    path: "/",
    element: <IspPage />,
  },
  {
    path: "/mvno",
    element: (
      <Suspense fallback={null}>
        <MvnoPage />
      </Suspense>
    ),
  },
  {
    path: "/payment-confirmed",
    element: <PaymentConfirmed />,
  },
  {
    path: "/suporte/:companyId",
    element: <Support />,
  },
]);
